{
  "statusMessage": "done successfully",
  "cards": [
    {
      "card": {
        "card": {
          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
          "info": {
            "id": "64173",
            "name": "KFC",
            "city": "Kolkata",
            "slugs": {
              "restaurant": "kfc-forum-rangoli-mall-howrah",
              "city": "kolkata"
            },
            "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
            "cloudinaryImageId": "f01666ac73626461d7455d9c24005cd4",
            "locality": "Rangoli Mall",
            "areaName": "Liluah",
            "costForTwo": "45000",
            "costForTwoMessage": "₹450 for two",
            "cuisines": [
              "Burgers",
              "Biryani"
            ],
            "avgRating": 4.2,
            "feeDetails": {
              "restaurantId": "64173",
              "fees": [
                {
                  "name": "distance",
                  "fee": 3800
                },
                {
                  "name": "time"
                },
                {
                  "name": "special"
                }
              ],
              "totalFee": 3800,
              "icon": "v1648635511/Delivery_fee_new_cjxumu",
              "message": "0.8 kms | ₹38 Delivery fee will apply"
            },
            "parentId": "547",
            "avgRatingString": "4.2",
            "totalRatingsString": "5K+ ratings",
            "sla": {
              "restaurantId": "64173",
              "deliveryTime": 27,
              "minDeliveryTime": 25,
              "maxDeliveryTime": 30,
              "lastMileTravel": 0.9,
              "serviceability": "SERVICEABLE",
              "stressFactor": 1,
              "rainMode": "RAIN_MODE_NONE",
              "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
              "zoneId": 473,
              "slaString": "25-30 MINS",
              "lastMileTravelString": "0.8 km",
              "iconType": "ICON_TYPE_EMPTY"
            },
            "availability": {
              "nextCloseTime": "2024-02-08 23:00:00",
              "visibility": true,
              "opened": true,
              "restaurantClosedMeta": {}
            },
            "aggregatedDiscountInfo": {
              "header": "Get items under 179",
              "shortDescriptionList": [
                {
                  "meta": "Get items under 179",
                  "discountType": "FinalPrice",
                  "operationType": "RESTAURANT"
                },
                {
                  "discountType": "Percentage",
                  "operationType": "RESTAURANT"
                }
              ],
              "descriptionList": [
                {
                  "meta": "Get items under 179",
                  "discountType": "FinalPrice",
                  "operationType": "RESTAURANT"
                },
                {
                  "meta": "20% off up to ₹125 | Use KOTAK125 Above ₹500",
                  "discountType": "Percentage",
                  "operationType": "RESTAURANT"
                }
              ],
              "visible": true
            },
            "badges": {},
            "slugString": "kfc-forum-rangoli-mall-howrah",
            "multiOutlet": true,
            "isOpen": true,
            "labels": [
              {
                "title": "Timings",
                "message": "null"
              },
              {
                "title": "Address",
                "message": "KFC Forum Rangoli Mall 212,Girish Ghosh Road, Belur Howrah West Bengal-711202"
              },
              {
                "title": "Cuisines",
                "message": "Burgers,Biryani"
              }
            ],
            "logo": "marketing-dashboard/carousel/jieoyuprsn64ubnthg0f",
            "totalRatings": 5000,
            "aggregatedDiscountInfoV2": {
              "header": "Get items under 179",
              "shortDescriptionList": [
                {
                  "meta": "Get items under 179",
                  "discountType": "FinalPrice",
                  "operationType": "RESTAURANT"
                },
                {
                  "discountType": "Percentage",
                  "operationType": "RESTAURANT"
                }
              ],
              "descriptionList": [
                {
                  "meta": "Get items under 179",
                  "discountType": "FinalPrice",
                  "operationType": "RESTAURANT"
                },
                {
                  "meta": "20% off up to ₹125 | Use KOTAK125 Above ₹500",
                  "discountType": "Percentage",
                  "operationType": "RESTAURANT"
                }
              ],
              "couponDetailsCta": "View coupon details"
            },
            "type": "F",
            "nudgeBanners": [
              {
                "priority": 1,
                "discountInfo": {
                  "discountType": "FinalPrice",
                  "value": 179
                },
                "unlockedMessage": "Deal of the Day unlocked!",
                "minItemCount": 1,
                "maxItemCount": 1,
                "type": "SILD",
                "nudgeTagInfo": {
                  "title": "Deal of the Day",
                  "fontName": "FONT_NAME_CONDENSED_BOLD"
                },
                "logoCtx": {}
              }
            ],
            "headerBanner": {
              "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/64173"
            },
            "expectationNotifiers": [
              {
                "text": "0.8 kms | ₹38 Delivery fee will apply",
                "icon": {
                  "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                },
                "popup": {
                  "cta": {}
                },
                "type": "DISTANCE_FEE_NON_FOOD_LM",
                "enrichedText": "<b>0.8 kms</b> | ₹38 Delivery fee will apply",
                "halfCardPopup": {
                  "halfCardPopupHeader": {}
                }
              }
            ],
            "generalPurposeInfoListV2": [
              {
                "cta": {
                  "info": {
                    "recordings": {}
                  },
                  "linkCta": {}
                }
              }
            ],
            "ratingSlab": "RATING_SLAB_5",
            "orderabilityCommunication": {
              "title": {},
              "subTitle": {},
              "message": {},
              "customIcon": {}
            },
            "hasBestsellerItems": true,
            "cartOrderabilityNudgeBanner": {
              "parameters": {},
              "presentation": {}
            },
            "latLong": "22.62387487,88.3538593"
          },
          "analytics": {}
        },
        "relevance": {
          "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
          "sectionId": "POP_UP_CROUTON_MENU"
        }
      }
    },
    {
      "card": {
        "card": {
          "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
          "layout": {
            "rows": 1,
            "columns": 3,
            "horizontalScrollEnabled": true,
            "itemSpacing": 12,
            "lineSpacing": 10,
            "widgetPadding": {},
            "containerStyle": {
              "containerPadding": {
                "left": 10,
                "right": 10,
                "bottom": 16
              }
            },
            "scrollBar": {}
          },
          "id": "offerCollectionWidget_UX4",
          "gridElements": {
            "infoWithStyle": {
              "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
              "offers": [
                {
                  "info": {
                    "header": "ITEMS AT ₹179",
                    "offerTag": "DEAL OF DAY",
                    "offerTagColor": "#E46D47",
                    "offerIds": [
                      "0d4da3be-4e98-4c00-b71f-f802b9982b98"
                    ],
                    "expiryTime": "1970-01-01T14:11:00Z",
                    "description": "ON SELECT ITEMS |",
                    "offerType": "offers",
                    "restId": "64173",
                    "offerLogo": "offers/deal-of-day",
                    "descriptionTextColor": "#7302060C",
                    "showExpiryTimer": true
                  },
                  "cta": {
                    "type": "OFFER_HALF_CARD"
                  }
                },
                {
                  "info": {
                    "header": "20% OFF UPTO ₹125",
                    "offerTagColor": "#E46D47",
                    "logoBottom": "rng/md/ads/production/4abdba6754dfedb04324150e316a4004",
                    "offerIds": [
                      "78d1d7e9-27ea-4c0d-9c48-26b48a643035"
                    ],
                    "expiryTime": "1970-01-01T00:00:00Z",
                    "couponCode": "USE KOTAK125",
                    "description": "ABOVE ₹500",
                    "offerType": "offers",
                    "restId": "64173",
                    "offerLogo": "rng/md/ads/production/4abdba6754dfedb04324150e316a4004",
                    "descriptionTextColor": "#7302060C"
                  },
                  "cta": {
                    "type": "OFFER_HALF_CARD"
                  }
                },
                {
                  "info": {
                    "header": "FLAT ₹30 OFF",
                    "offerTagColor": "#E46D47",
                    "logoBottom": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                    "offerIds": [
                      "269c382d-796f-45cd-bd15-0b8b891c5e0c"
                    ],
                    "expiryTime": "1970-01-01T00:00:00Z",
                    "couponCode": "USE SIMPL30",
                    "description": "ABOVE ₹300",
                    "offerType": "offers",
                    "restId": "64173",
                    "offerLogo": "rng/md/ads/production/7f31c9e47ddd7e6a3c16d21553c0ca60",
                    "descriptionTextColor": "#7302060C"
                  },
                  "cta": {
                    "type": "OFFER_HALF_CARD"
                  }
                }
              ],
              "habitMilestoneInfo": {
                "callout": {}
              },
              "loyaltyDiscoverPresentationInfo": {
                "logoCtx": {}
              }
            }
          }
        }
      }
    },
    {
      "groupedCard": {
        "cardGroupMap": {
          "REGULAR": {
            "cards": [
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                    "badges": {},
                    "vegOnlyDetails": {
                      "imageId": "AutoVegOnly_qkjowj",
                      "title": "Showing only vegetarian options.",
                      "description": "Tap on the VEG ONLY button to turn off the setting"
                    },
                    "topRatedFilter": {},
                    "kidsCategoryFilter": {
                      "attributes": {
                        "displayText": "Kids Favourites",
                        "tooltip": {
                          "enabled": true,
                          "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                        }
                      }
                    },
                    "vegFilter": {
                      "attributes": {
                        "displayText": "VEG"
                      }
                    },
                    "nonvegFilter": {
                      "attributes": {
                        "displayText": "NONVEG"
                      }
                    }
                  },
                  "relevance": {
                    "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                    "sectionId": "MENU_FILTER_TOGGLE"
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                    "title": "Top Picks",
                    "carousel": [
                      {
                        "type": "TopCarousel",
                        "subtype": "image",
                        "bannerId": "1722205",
                        "creativeId": "TopPicks/CknChizza",
                        "title": "Chicken Chizza",
                        "description": " ",
                        "fontColor": "#FFFFFF",
                        "dish": {
                          "info": {
                            "id": "108267602",
                            "name": "Chicken Chizza",
                            "category": "CHICKEN CHIZZA",
                            "description": "Crunchy chicken topped with cheese, spicy sauce, veggies & herbs. All-chicken-no-crust pizza! [Serves 1]",
                            "imageId": "5108c304c25e2360d28588a461e1f210",
                            "inStock": 1,
                            "price": 31905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005339",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "type": "TopCarousel",
                        "subtype": "image",
                        "bannerId": "1681012",
                        "creativeId": "TopPicks/USavBucket",
                        "title": "Ultimate Savings Chicken Bucket",
                        "description": " ",
                        "fontColor": "#FFFFFF",
                        "dish": {
                          "info": {
                            "id": "99453187",
                            "name": "Ultimate Savings Chicken Bucket",
                            "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                            "description": "Savings of 35% on signature bucket of 4pc Hot & crispy chicken, 6 Pc Wings, 4 Chicken Peri Peri Boneless strips, 2 Dips (20 gms each) & a Pepsi PET 475ml [serves 2-3 ]",
                            "imageId": "edbffde0880bbe400d26c5e152a6f088",
                            "inStock": 1,
                            "price": 69905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004212",
                                "groupName": "Choose your sides",
                                "choices": [
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004220",
                                "groupName": "Choose Your Snack",
                                "choices": [
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004227",
                                "groupName": "Choose your beverages",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004231",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "itemBadge": {},
                            "badgesV2": {}
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "type": "TopCarousel",
                        "subtype": "image",
                        "bannerId": "1723145",
                        "creativeId": "TopPicks/CknChizWM",
                        "title": "Chicken Chizza & Wings Meal",
                        "description": " ",
                        "fontColor": "#FFFFFF",
                        "dish": {
                          "info": {
                            "id": "127996962",
                            "name": "Chicken Chizza & Wings Meal",
                            "category": "CHICKEN CHIZZA",
                            "description": "All-chicken-no-crust Chizza, 2 Pc Hot Wings and a Pepsi PET 475ml at a deal price [Serves 1-2]",
                            "imageId": "120374790af673aae76c5a5d883d45ad",
                            "inStock": 1,
                            "price": 45905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005267",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "itemBadge": {},
                            "badgesV2": {}
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "type": "TopCarousel",
                        "subtype": "image",
                        "bannerId": "1644072",
                        "creativeId": "TopPicks/ZPBCMeal",
                        "title": "Zinger Pro Burger & Chicken Meal",
                        "description": " ",
                        "fontColor": "#FFFFFF",
                        "dish": {
                          "info": {
                            "id": "122148901",
                            "name": "Zinger Pro Burger & Chicken Meal",
                            "category": "BURGERS",
                            "description": "New Zinger Pro premium Burger with 1 Pc Hot & Crispy and Pepsi PET 475ml at a deal price",
                            "imageId": "6bafd5f307841d1025401757c7be3521",
                            "inStock": 1,
                            "price": 39905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004977",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "itemBadge": {},
                            "badgesV2": {}
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "type": "TopCarousel",
                        "subtype": "image",
                        "bannerId": "1644983",
                        "creativeId": "TopPicks/AOCBucket",
                        "title": "All in One Chicken Bucket",
                        "description": " ",
                        "fontColor": "#FFFFFF",
                        "dish": {
                          "info": {
                            "id": "117825786",
                            "name": "All in One Chicken Bucket",
                            "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                            "description": "Save 24% with variety bucket of 1 Leg Pc, 1 Hot & Crispy, 2 Wings, 2 Strips, 1 Zinger Fillet, 3 Dips [20gm each] & 1 Pepsi 475 ml [Serves 2-3]",
                            "imageId": "31f899d11feb6a4bc6b3af7815e0f06f",
                            "inStock": 1,
                            "price": 54857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004256",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004264",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004269",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004276",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "itemBadge": {},
                            "badgesV2": {}
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "type": "TopCarousel",
                        "subtype": "image",
                        "bannerId": "1645984",
                        "creativeId": "TopPicks/Big8",
                        "title": "Big 8 - Chicken Bucket",
                        "description": " ",
                        "fontColor": "#FFFFFF",
                        "dish": {
                          "info": {
                            "id": "41222660",
                            "name": "Big 8 - Chicken Bucket",
                            "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                            "description": "Save 27% on this variety bucket of 4pc Hot & Crispy chicken & 4pc Smoky Red chicken [serves 2- 3 ]",
                            "imageId": "yiozpo7vfq8t5s4hns1v",
                            "inStock": 1,
                            "price": 69905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136552986",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "itemBadge": {},
                            "badgesV2": {}
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "type": "TopCarousel",
                        "subtype": "image",
                        "bannerId": "1646888",
                        "creativeId": "TopPicks/CBBMeal",
                        "title": "Chicken Burger Buddy Meal",
                        "description": " ",
                        "fontColor": "#FFFFFF",
                        "dish": {
                          "info": {
                            "id": "63220524",
                            "name": "Chicken Burger Buddy Meal",
                            "category": "BURGERS",
                            "description": "Save Rs. 40 & Share 2 Classic Chicken Zinger Burgers & a Medium Chicken Popcorn in this delightful combo for 2",
                            "imageId": "8f9137a6bae94a4d61fcc4fa1c3c15cd",
                            "inStock": 1,
                            "price": 52857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004953",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "itemBadge": {},
                            "badgesV2": {}
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "Recommended",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "108267602",
                            "name": "Chicken Chizza",
                            "category": "CHICKEN CHIZZA",
                            "description": "Crunchy chicken topped with cheese, spicy sauce, veggies & herbs. All-chicken-no-crust pizza! [Serves 1]",
                            "imageId": "5108c304c25e2360d28588a461e1f210",
                            "inStock": 1,
                            "price": 31905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005339",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.0",
                                "ratingCount": "41 ratings",
                                "ratingCountV2": "41"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "127996967",
                            "name": "Chicken Chizza & Dessert Meal",
                            "category": "CHICKEN CHIZZA",
                            "description": "All-chicken-no-crust Chizza, Choco Lava Cake and a Pepsi PET 475ml at a deal price [Serves 1-2]",
                            "imageId": "e4d425ed2f059e4e12c8b905f3bc7d99",
                            "inStock": 1,
                            "price": 46857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005315",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "111579851",
                            "name": "Chicken Chizza & Pepsi Combo",
                            "category": "CHICKEN CHIZZA",
                            "description": "1 Crunchy all-chicken-no-crust Chizza served with Pepsi PET 475ml [Serves 1]",
                            "imageId": "aa3caff35ff99fab3dadcd1121a962ce",
                            "inStock": 1,
                            "price": 37619,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "108267600",
                            "name": "Duo Chicken Chizza",
                            "category": "CHICKEN CHIZZA",
                            "description": "2 Crunchy all-chicken-no-crust Chizza topped with cheese, spicy sauce, veggies & herbs [Serves 2-3]",
                            "imageId": "302d1fbc468a89dbc497f3181827a7f5",
                            "inStock": 1,
                            "price": 62857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005279",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "127996962",
                            "name": "Chicken Chizza & Wings Meal",
                            "category": "CHICKEN CHIZZA",
                            "description": "All-chicken-no-crust Chizza, 2 Pc Hot Wings and a Pepsi PET 475ml at a deal price [Serves 1-2]",
                            "imageId": "120374790af673aae76c5a5d883d45ad",
                            "inStock": 1,
                            "price": 45905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005267",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528360",
                            "name": "Plain Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "New Plain Rice Bowlz",
                            "imageId": "38c021b7322ea7451ad6668b1e0706be",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 13905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528359",
                            "name": "Popcorn Chicken Rice Bowlz & Wings Meal",
                            "category": "RICE BOWLZ",
                            "description": "Deal Savings of Rs. 118 on 2 units of Popcorn Chicken Rice Bowlz and 8 Pc Hot Wings [Serves 3-4]",
                            "imageId": "8239f998f8dd9b79b00ed459ff995ca0",
                            "inStock": 1,
                            "price": 69905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528358",
                            "name": "Veg Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "Aromatic Veg rice bowl mixed with spicy gravy [serves 1]",
                            "imageId": "b55628a57b4ae927013617605d4db6e6",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 19905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528350",
                            "name": "Popcorn Chicken Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "Aromatic Poprcorn Chicken rice bowl mixed with spicy gravy [serves 1]",
                            "imageId": "9e57b3b9478a4a0b114b8ba4e1b5be89",
                            "inStock": 1,
                            "price": 22952,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528347",
                            "name": "Smoky Red Chicken Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "Aromatic Smoky Red Chicken rice bowl mixed with spicy gravy [serves 1]",
                            "imageId": "3e243b6fbc280b8891643b1d3b7836f6",
                            "inStock": 1,
                            "price": 22952,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.6",
                                "ratingCount": "3 ratings",
                                "ratingCountV2": "3"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528345",
                            "name": "Classic Chicken Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "Aromatic Hot & Crispy Chicken rice bowl mixed with spicy gravy [serves 1]",
                            "imageId": "a74de1a2b59bf60d616d458b7e78bd1a",
                            "inStock": 1,
                            "price": 22952,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528343",
                            "name": "Duo Popcorn Chicken Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "Save Rs. 30 on aromatic Hot & Crispy Chicken rice bowl mixed with spicy gravy [serves 2]",
                            "imageId": "30eb3662da29c0e469299b2149aa4600",
                            "inStock": 1,
                            "price": 42857,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148915",
                            "name": "Zinger Pro Burger & Popcorn Meal",
                            "category": "BURGERS",
                            "description": "New Zinger Pro premium Burger with Medium Popcorn and Pepsi PET 475ml at a deal price",
                            "imageId": "9b153dffd3829fb695a66e4fd7182b6c",
                            "inStock": 1,
                            "price": 45905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005028",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005031",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005036",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005042",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005046",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148904",
                            "name": "Zinger Pro Burger",
                            "category": "BURGERS",
                            "description": "Premium burger with crunchy chicken, Mexican Habanero sauce, cheese, tomato & onion",
                            "imageId": "36901b422d759c19c2799c10eeb416c8",
                            "inStock": 1,
                            "price": 23905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004998",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005001",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005004",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005009",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005015",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.8",
                                "ratingCount": "3 ratings",
                                "ratingCountV2": "3"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148901",
                            "name": "Zinger Pro Burger & Chicken Meal",
                            "category": "BURGERS",
                            "description": "New Zinger Pro premium Burger with 1 Pc Hot & Crispy and Pepsi PET 475ml at a deal price",
                            "imageId": "6bafd5f307841d1025401757c7be3521",
                            "inStock": 1,
                            "price": 39905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004977",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220524",
                            "name": "Chicken Burger Buddy Meal",
                            "category": "BURGERS",
                            "description": "Save Rs. 40 & Share 2 Classic Chicken Zinger Burgers & a Medium Chicken Popcorn in this delightful combo for 2",
                            "imageId": "8f9137a6bae94a4d61fcc4fa1c3c15cd",
                            "inStock": 1,
                            "price": 52857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004953",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.3",
                                "ratingCount": "84 ratings",
                                "ratingCountV2": "84"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148894",
                            "name": "Chicken Zinger Burger - Classic with Cheese",
                            "category": "BURGERS",
                            "description": "Signature burger with a crunchy chicken fillet, cheese slice, veggies & a delicious mayo sauce",
                            "imageId": "418e7dc325cf65d7c1d9faab2e646421",
                            "inStock": 1,
                            "price": 22405,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136553053",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553055",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553059",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553064",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553066",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "60819953",
                            "name": "Mixed Chicken Zinger Burger Doubles",
                            "category": "BURGERS",
                            "description": "Save Rs.41 on Best-seller combo of classic chicken Zinger & Tandoori zinger burgers",
                            "imageId": "dd434d7cd80de42b3d04cb979aeacb46",
                            "inStock": 1,
                            "price": 36857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004893",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.3",
                                "ratingCount": "168 ratings",
                                "ratingCountV2": "168"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148888",
                            "name": "Chicken Zinger Burger - Tandoori with Cheese",
                            "category": "BURGERS",
                            "description": "Chicken zinger with a?delicious tandoori sauce & cheese slice",
                            "imageId": "7af6cdbf96ad445ebfce65f568fd0adf",
                            "inStock": 1,
                            "price": 23357,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136553025",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553030",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553033",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553036",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553038",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.9",
                                "ratingCount": "4 ratings",
                                "ratingCountV2": "4"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148886",
                            "name": "Veg Zinger Burger with Cheese",
                            "category": "BURGERS",
                            "description": "Signature veg burger with crispy patties, cheese slice, veggies & a tangy sauce",
                            "imageId": "6d8c645fcd7d5368741ccc61933fafed",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 21357,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136553005",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553009",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553013",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553015",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "showImage": true,
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ],
                    "type": "CATEGORY_TYPE_RECOMMENDED"
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "CHICKEN CHIZZA",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "108267602",
                            "name": "Chicken Chizza",
                            "category": "CHICKEN CHIZZA",
                            "description": "Crunchy chicken topped with cheese, spicy sauce, veggies & herbs. All-chicken-no-crust pizza! [Serves 1]",
                            "imageId": "5108c304c25e2360d28588a461e1f210",
                            "inStock": 1,
                            "price": 31905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005339",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.0",
                                "ratingCount": "41 ratings",
                                "ratingCountV2": "41"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "127996967",
                            "name": "Chicken Chizza & Dessert Meal",
                            "category": "CHICKEN CHIZZA",
                            "description": "All-chicken-no-crust Chizza, Choco Lava Cake and a Pepsi PET 475ml at a deal price [Serves 1-2]",
                            "imageId": "e4d425ed2f059e4e12c8b905f3bc7d99",
                            "inStock": 1,
                            "price": 46857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005315",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "111579851",
                            "name": "Chicken Chizza & Pepsi Combo",
                            "category": "CHICKEN CHIZZA",
                            "description": "1 Crunchy all-chicken-no-crust Chizza served with Pepsi PET 475ml [Serves 1]",
                            "imageId": "aa3caff35ff99fab3dadcd1121a962ce",
                            "inStock": 1,
                            "price": 37619,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "108267600",
                            "name": "Duo Chicken Chizza",
                            "category": "CHICKEN CHIZZA",
                            "description": "2 Crunchy all-chicken-no-crust Chizza topped with cheese, spicy sauce, veggies & herbs [Serves 2-3]",
                            "imageId": "302d1fbc468a89dbc497f3181827a7f5",
                            "inStock": 1,
                            "price": 62857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005279",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "127996962",
                            "name": "Chicken Chizza & Wings Meal",
                            "category": "CHICKEN CHIZZA",
                            "description": "All-chicken-no-crust Chizza, 2 Pc Hot Wings and a Pepsi PET 475ml at a deal price [Serves 1-2]",
                            "imageId": "120374790af673aae76c5a5d883d45ad",
                            "inStock": 1,
                            "price": 45905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005267",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "RICE BOWLZ",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528360",
                            "name": "Plain Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "New Plain Rice Bowlz",
                            "imageId": "38c021b7322ea7451ad6668b1e0706be",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 13905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528359",
                            "name": "Popcorn Chicken Rice Bowlz & Wings Meal",
                            "category": "RICE BOWLZ",
                            "description": "Deal Savings of Rs. 118 on 2 units of Popcorn Chicken Rice Bowlz and 8 Pc Hot Wings [Serves 3-4]",
                            "imageId": "8239f998f8dd9b79b00ed459ff995ca0",
                            "inStock": 1,
                            "price": 69905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528358",
                            "name": "Veg Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "Aromatic Veg rice bowl mixed with spicy gravy [serves 1]",
                            "imageId": "b55628a57b4ae927013617605d4db6e6",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 19905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528350",
                            "name": "Popcorn Chicken Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "Aromatic Poprcorn Chicken rice bowl mixed with spicy gravy [serves 1]",
                            "imageId": "9e57b3b9478a4a0b114b8ba4e1b5be89",
                            "inStock": 1,
                            "price": 22952,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528347",
                            "name": "Smoky Red Chicken Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "Aromatic Smoky Red Chicken rice bowl mixed with spicy gravy [serves 1]",
                            "imageId": "3e243b6fbc280b8891643b1d3b7836f6",
                            "inStock": 1,
                            "price": 22952,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.6",
                                "ratingCount": "3 ratings",
                                "ratingCountV2": "3"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528345",
                            "name": "Classic Chicken Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "Aromatic Hot & Crispy Chicken rice bowl mixed with spicy gravy [serves 1]",
                            "imageId": "a74de1a2b59bf60d616d458b7e78bd1a",
                            "inStock": 1,
                            "price": 22952,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "129528343",
                            "name": "Duo Popcorn Chicken Rice Bowlz",
                            "category": "RICE BOWLZ",
                            "description": "Save Rs. 30 on aromatic Hot & Crispy Chicken rice bowl mixed with spicy gravy [serves 2]",
                            "imageId": "30eb3662da29c0e469299b2149aa4600",
                            "inStock": 1,
                            "price": 42857,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "BURGERS",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148915",
                            "name": "Zinger Pro Burger & Popcorn Meal",
                            "category": "BURGERS",
                            "description": "New Zinger Pro premium Burger with Medium Popcorn and Pepsi PET 475ml at a deal price",
                            "imageId": "9b153dffd3829fb695a66e4fd7182b6c",
                            "inStock": 1,
                            "price": 45905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134005028",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005031",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005036",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005042",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005046",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148904",
                            "name": "Zinger Pro Burger",
                            "category": "BURGERS",
                            "description": "Premium burger with crunchy chicken, Mexican Habanero sauce, cheese, tomato & onion",
                            "imageId": "36901b422d759c19c2799c10eeb416c8",
                            "inStock": 1,
                            "price": 23905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004998",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005001",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005004",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005009",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134005015",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.8",
                                "ratingCount": "3 ratings",
                                "ratingCountV2": "3"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148901",
                            "name": "Zinger Pro Burger & Chicken Meal",
                            "category": "BURGERS",
                            "description": "New Zinger Pro premium Burger with 1 Pc Hot & Crispy and Pepsi PET 475ml at a deal price",
                            "imageId": "6bafd5f307841d1025401757c7be3521",
                            "inStock": 1,
                            "price": 39905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004977",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220524",
                            "name": "Chicken Burger Buddy Meal",
                            "category": "BURGERS",
                            "description": "Save Rs. 40 & Share 2 Classic Chicken Zinger Burgers & a Medium Chicken Popcorn in this delightful combo for 2",
                            "imageId": "8f9137a6bae94a4d61fcc4fa1c3c15cd",
                            "inStock": 1,
                            "price": 52857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004953",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.3",
                                "ratingCount": "84 ratings",
                                "ratingCountV2": "84"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148894",
                            "name": "Chicken Zinger Burger - Classic with Cheese",
                            "category": "BURGERS",
                            "description": "Signature burger with a crunchy chicken fillet, cheese slice, veggies & a delicious mayo sauce",
                            "imageId": "418e7dc325cf65d7c1d9faab2e646421",
                            "inStock": 1,
                            "price": 22405,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136553053",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553055",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553059",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553064",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553066",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "60819953",
                            "name": "Mixed Chicken Zinger Burger Doubles",
                            "category": "BURGERS",
                            "description": "Save Rs.41 on Best-seller combo of classic chicken Zinger & Tandoori zinger burgers",
                            "imageId": "dd434d7cd80de42b3d04cb979aeacb46",
                            "inStock": 1,
                            "price": 36857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004893",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.3",
                                "ratingCount": "168 ratings",
                                "ratingCountV2": "168"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148888",
                            "name": "Chicken Zinger Burger - Tandoori with Cheese",
                            "category": "BURGERS",
                            "description": "Chicken zinger with a?delicious tandoori sauce & cheese slice",
                            "imageId": "7af6cdbf96ad445ebfce65f568fd0adf",
                            "inStock": 1,
                            "price": 23357,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136553025",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553030",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553033",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553036",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553038",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.9",
                                "ratingCount": "4 ratings",
                                "ratingCountV2": "4"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "122148886",
                            "name": "Veg Zinger Burger with Cheese",
                            "category": "BURGERS",
                            "description": "Signature veg burger with crispy patties, cheese slice, veggies & a tangy sauce",
                            "imageId": "6d8c645fcd7d5368741ccc61933fafed",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 21357,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136553005",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553009",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553013",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136553015",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220476",
                            "name": "Chicken Zinger Burger - Classic",
                            "category": "BURGERS",
                            "description": "Signature chicken burger made with a crunchy chicken fillet, veggies & a delicious mayo sauce",
                            "imageId": "d5bc5b32dd177f5f207cad66556a572b",
                            "inStock": 1,
                            "price": 19905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004767",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004775",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004781",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004785",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004788",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.1",
                                "ratingCount": "183 ratings",
                                "ratingCountV2": "183"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "16702980",
                            "name": "Veg Zinger Burger",
                            "category": "BURGERS",
                            "description": "Signature veg burger with crispy patties, veggies & a tangy sauce",
                            "imageId": "a403a55dc5b74cc6acfcfa755f30c165",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 18857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004744",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.7",
                                "ratingCount": "183 ratings",
                                "ratingCountV2": "183"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220498",
                            "name": "Chicken Zinger Burger - Tandoori",
                            "category": "BURGERS",
                            "description": "Chicken zinger with a delicious tandoori sauce",
                            "imageId": "af3699168db40a2dbadc372d87338e97",
                            "inStock": 1,
                            "price": 20857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004724",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.2",
                                "ratingCount": "193 ratings",
                                "ratingCountV2": "193"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "65737510",
                            "name": "2 X Chicken Krisper Burgers",
                            "category": "BURGERS",
                            "description": "2 delicious chicken value burgers - at a deal price",
                            "imageId": "ufzxglygurm6dowpbc2t",
                            "inStock": 1,
                            "price": 24857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004675",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004684",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004692",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004698",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004705",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.3",
                                "ratingCount": "138 ratings",
                                "ratingCountV2": "138"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "65737506",
                            "name": "2 X Veg Krisper Burgers",
                            "category": "BURGERS",
                            "description": "2 delicious veg value burgers - at a deal price",
                            "imageId": "cvqb24o2vlkd967jzzas",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 17905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004628",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004631",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004643",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004651",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.2",
                                "ratingCount": "84 ratings",
                                "ratingCountV2": "84"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25%)",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113591201",
                            "name": "Peri Peri 10 Pc Chicken Strips & 2 Dips",
                            "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25%)",
                            "description": "Save 24% with the indulging 10 Piece Peri Peri Boneless Strips and 2 Dips [Serves 2-3]",
                            "imageId": "a0feef07b2a9d72ba02f4a7d53e46948",
                            "inStock": 1,
                            "price": 49905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004591",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004596",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004598",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004603",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.6",
                                "ratingCount": "7 ratings",
                                "ratingCountV2": "7"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "124522518",
                            "name": "Peri Peri Chicken 5 Leg Piece & 2 Dips",
                            "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25%)",
                            "description": "Save Rs 120 on 5 Spicy Peri Peri Leg Pieces, paired with 2 delicous dips (20gm each) [serves 2]",
                            "imageId": "dxzn6bfxdqcyda1gqrct",
                            "inStock": 1,
                            "price": 51905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.6",
                                "ratingCount": "5 ratings",
                                "ratingCountV2": "5"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "124522517",
                            "name": "Peri Peri 10 Leg Pc & 4 Dips",
                            "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25%)",
                            "description": "Save Rs. 334 on 10 Spicy Peri Peri Leg Pieces & 4 Dips (20gm each) [serves 3-4]",
                            "imageId": "ye1imbdqn5efc7vheuah",
                            "inStock": 1,
                            "price": 94857,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "99453141",
                            "name": "Peri Peri Chicken Strips - 6 Pc",
                            "category": "PERI PERI CHICKEN STRIPS & LEG PC (UP TO 25%)",
                            "description": "Save 16% with on savouring 6 Spicy Peri Peri chicken boneless strips [serves 2]",
                            "imageId": "qsmfyjef2hbu05emuu2c",
                            "inStock": 1,
                            "price": 29905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004544",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.3",
                                "ratingCount": "57 ratings",
                                "ratingCountV2": "57"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "121147687",
                            "name": "Chicken Bucket for Two",
                            "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                            "description": "Flat Rs. 115 off with this variety combo of 2pc Hot & Crispy Chicken, 2 pc Smoky Red Grilled Chicken & a Large Chicken Popcorn [serves 2-3]",
                            "imageId": "wmn6qpsqazt1ln8hylum",
                            "inStock": 1,
                            "price": 59905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136552989",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136552991",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136552992",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136552994",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "136552996",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "67884802",
                            "name": "Chicken Krisper Burger Combo",
                            "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                            "description": "Save Rs. 57 on Deal combo of 2 chicken value burgers, 2 pc Hot & Crispy, 2 dips (20gm each) & a chilled Pepsi PET 475 ml [Serves 1-2]",
                            "imageId": "m038pslx2jfyqgdmlgch",
                            "inStock": 1,
                            "price": 53905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004475",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.5",
                                "ratingCount": "40 ratings",
                                "ratingCountV2": "40"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "59939300",
                            "name": "Chicken Mingles Bucket Meal",
                            "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                            "description": "Save Rs. 63 on this crowd favorite combo of 4 Hot Wings, 2 Chicken Peri Peri Boneless Strips, a Reg Popcorn, medium fries & a chilled Pepsi PET 475ml [serves 2 ]",
                            "imageId": "kt0vzw4bzztarxnl0wcl",
                            "inStock": 1,
                            "price": 49905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004414",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004421",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004425",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004429",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.1",
                                "ratingCount": "38 ratings",
                                "ratingCountV2": "38"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "56344366",
                            "name": "Chicken & French Fries Bucket",
                            "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                            "description": "Crowd-favorite combo of 2pc Hot & Crispy Chicken with Medium French Fries",
                            "imageId": "pasdg6owucvi23hcp9eb",
                            "inStock": 1,
                            "price": 29905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004351",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004357",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004363",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004374",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004381",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.4",
                                "ratingCount": "55 ratings",
                                "ratingCountV2": "55"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "56344362",
                            "name": "Chicken Popcorn & French Fries Bucket",
                            "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                            "description": "Large Chicken Popcorn with Med French Fries - at a deal price",
                            "imageId": "raq6sxtwfb9fvbd6bakq",
                            "inStock": 1,
                            "price": 31905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004313",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004319",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004325",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004330",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.3",
                                "ratingCount": "84 ratings",
                                "ratingCountV2": "84"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "65737504",
                            "name": "2 X Veg Krispers Burger Meal",
                            "category": "BUCKETS/ MEALS FOR 1-2 (UP TO 15% OFF)",
                            "description": "Save Rs. 49 with 2 veg value burgers, crispy Medium French Fries & 2 delicious Dips at a deal price! [Serves 1-2]",
                            "imageId": "xdzkcjjgypmjcwhikqae",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 28857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004289",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004292",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.1",
                                "ratingCount": "68 ratings",
                                "ratingCountV2": "68"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "117825786",
                            "name": "All in One Chicken Bucket",
                            "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                            "description": "Save 24% with variety bucket of 1 Leg Pc, 1 Hot & Crispy, 2 Wings, 2 Strips, 1 Zinger Fillet, 3 Dips [20gm each] & 1 Pepsi 475 ml [Serves 2-3]",
                            "imageId": "31f899d11feb6a4bc6b3af7815e0f06f",
                            "inStock": 1,
                            "price": 54857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004256",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004264",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004269",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004276",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "2.6",
                                "ratingCount": "5 ratings",
                                "ratingCountV2": "5"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "99453187",
                            "name": "Ultimate Savings Chicken Bucket",
                            "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                            "description": "Savings of 35% on signature bucket of 4pc Hot & crispy chicken, 6 Pc Wings, 4 Chicken Peri Peri Boneless strips, 2 Dips (20 gms each) & a Pepsi PET 475ml [serves 2-3 ]",
                            "imageId": "edbffde0880bbe400d26c5e152a6f088",
                            "inStock": 1,
                            "price": 69905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004212",
                                "groupName": "Choose your sides",
                                "choices": [
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004220",
                                "groupName": "Choose Your Snack",
                                "choices": [
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004227",
                                "groupName": "Choose your beverages",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004231",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.7",
                                "ratingCount": "27 ratings",
                                "ratingCountV2": "27"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "77314870",
                            "name": "Stay Home Chicken Bucket",
                            "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                            "description": "Save 24% & enjoy 4pc Hot & Crispy Chicken, 4 Hot Wings, 6 chicken peri peri boneless strips & 2 delicious dips (20gm each) [serves 3]",
                            "imageId": "nku1xlhmmifu1hxoiugt",
                            "inStock": 1,
                            "price": 79905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.8",
                                "ratingCount": "7 ratings",
                                "ratingCountV2": "7"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220239",
                            "name": "Big 12 - Chicken Bucket",
                            "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                            "description": "Save 26% on 6pc Hot & Crispy Chicken, 6 Hot Wings & 2 dips (20gm each) [serves 2- 3]",
                            "imageId": "yqxxwbdxoaconjcyb7ka",
                            "inStock": 1,
                            "price": 74857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004180",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.5",
                                "ratingCount": "15 ratings",
                                "ratingCountV2": "15"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "41222660",
                            "name": "Big 8 - Chicken Bucket",
                            "category": "BUCKETS/ MEALS FOR 3-4 (UP TO 35% OFF)",
                            "description": "Save 27% on this variety bucket of 4pc Hot & Crispy chicken & 4pc Smoky Red chicken [serves 2- 3 ]",
                            "imageId": "yiozpo7vfq8t5s4hns1v",
                            "inStock": 1,
                            "price": 69905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136552986",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.8",
                                "ratingCount": "89 ratings",
                                "ratingCountV2": "89"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "CHICKEN ROLLS",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113953190",
                            "name": "Double Chicken Roll Meal for 2",
                            "category": "CHICKEN ROLLS",
                            "description": "Save Rs. 23 with 2 KFC Double Chicken Roll with servings of 1 Large Fries, 2 delish dips and 1 Pepsi PET 475ml [2 units of Double Chicken Roll, Serves 2]",
                            "imageId": "xo2cpzgjtlbdsv3sdzsy",
                            "inStock": 1,
                            "price": 54857,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113953193",
                            "name": "Classic Chicken Roll Meal for 2",
                            "category": "CHICKEN ROLLS",
                            "description": "2 units of The classic KFC Chicken Roll with servings of 1 Large Fries, 2 delish dips and 1 Pepsi PET 475ml [2 units of Classic Chicken Roll, Serves 2]",
                            "imageId": "txepnr2oyy73hfpzxkow",
                            "inStock": 1,
                            "price": 47905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113953199",
                            "name": "Double Chicken Roll Meal for 1",
                            "category": "CHICKEN ROLLS",
                            "description": "Save Rs. 24 with a Double Chicken Roll with servings of 1 Large Fries, 2 delish dips and 1 Pepsi PET 475ml [1 unit of Double Chicken Roll, Serves 1]",
                            "imageId": "ecbrc7z6vrcrb5d3tfb7",
                            "inStock": 1,
                            "price": 37905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113953203",
                            "name": "Classic Chicken Roll Meal for 1",
                            "category": "CHICKEN ROLLS",
                            "description": "Save Rs. 14 on a classic KFC Chicken Roll with servings of 1 Large Fries, 2 delish dips and 1 Pepsi PET 475ml [1 unit of Classic Chicken Roll, Serves 1]",
                            "imageId": "lwl1wny7an69glqeu2kt",
                            "inStock": 1,
                            "price": 33905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113953185",
                            "name": "2 Double Chicken Rolls",
                            "category": "CHICKEN ROLLS",
                            "description": "2 Double Chicken Roll with double chicken strip filling, layerful parantha onions and two spicy sauce [2 units of Double Chicken Roll, Serves 1-2]",
                            "imageId": "b881c8de97cefa72c822926e43a38d32",
                            "inStock": 1,
                            "price": 32857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004051",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004056",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004063",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004071",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004076",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113953188",
                            "name": "2 Classic Chicken Rolls",
                            "category": "CHICKEN ROLLS",
                            "description": "Save Rs. 10 on 2 Street Syle Roll with Layerful parantha, single chicken strip, onions and two spicy sauce [2 units of Classic Chicken Roll, Serves 1-2]",
                            "imageId": "9c67bdcd5218f5b53a858f4665ad0dab",
                            "inStock": 1,
                            "price": 22857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134004021",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004023",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004027",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004032",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004036",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.8",
                                "ratingCount": "4 ratings",
                                "ratingCountV2": "4"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113953206",
                            "name": "Double Chicken Roll & Pepsi Combo",
                            "category": "CHICKEN ROLLS",
                            "description": "Double fun with double chicken strip filling, layerful parantha onions and two spicy sauce & Pepsi PET 475ml [1 unit of Double Chicken Roll, Serves 1]",
                            "imageId": "92f117d2f5163260c533bdb6b03c1ddc",
                            "inStock": 1,
                            "price": 22571,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003983",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003991",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003998",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004005",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134004010",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113953208",
                            "name": "Classic Chicken Roll & Pepsi Combo",
                            "category": "CHICKEN ROLLS",
                            "description": "Street Syle Roll with Layerful parantha, single chicken strip, onions and two spicy sauce & Pepsi PET 475ml [1 units of Classic Chicken Roll, Serves 1]",
                            "imageId": "b97f4414c5b8c2cd098f3f3ca2e9604f",
                            "inStock": 1,
                            "price": 17619,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003533",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003537",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003540",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003543",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003544",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "2.6",
                                "ratingCount": "3 ratings",
                                "ratingCountV2": "3"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113953195",
                            "name": "Double Chicken Roll",
                            "category": "CHICKEN ROLLS",
                            "description": "Double fun with double chicken strip filling, layerful parantha onions and two spicy sauce [1 unit of Double Chicken Roll, Serves 1]",
                            "imageId": "ebcda29a62123bbf8bb8a33bbe2ab847",
                            "inStock": 1,
                            "price": 16857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003510",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003512",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003514",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003516",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003518",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.1",
                                "ratingCount": "9 ratings",
                                "ratingCountV2": "9"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "VALUE SNACKERS",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "118353425",
                            "name": "Chicken Longer Burger & 2 Strips Combo",
                            "category": "VALUE SNACKERS",
                            "description": "Longgg burger with crunchy chicken, onions & a punchy sauce , served with 2 peri peri chicken strips",
                            "imageId": "e344aa3aac91a825e9d0d0e3f60eda4b",
                            "inStock": 1,
                            "price": 21905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003945",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003953",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319872",
                                    "name": "Hot & Crispy Chicken - 1 pc",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003958",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003966",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003970",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.5",
                                "ratingCount": "11 ratings",
                                "ratingCountV2": "11"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "121921376",
                            "name": "2 X Veg Longer Burger",
                            "category": "VALUE SNACKERS",
                            "description": "The really long burger with Veg Patty, Onion, Lettuce and two sauces",
                            "imageId": "866ef0fcc37944827cf419f6d9783d97",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 19810,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003931",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "113953197",
                            "name": "Classic Chicken Roll",
                            "category": "VALUE SNACKERS",
                            "description": "Street style roll with single chicken strip, onions and two spicy sauce [1 unit of Roll]",
                            "imageId": "ebd8e706049e4fd5ca79ecf708f8ecba",
                            "inStock": 1,
                            "price": 11905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.9",
                                "ratingCount": "11 ratings",
                                "ratingCountV2": "11"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "123960292",
                            "name": "2 X Veg?Roll",
                            "category": "VALUE SNACKERS",
                            "description": "Try the amazing Veg Roll [2 units of Veg Roll]",
                            "imageId": "f6db48f08a27a8bf10ce1ad5567da0e6",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 22857,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "123960293",
                            "name": "Veg Roll Meal",
                            "category": "VALUE SNACKERS",
                            "description": "Deal meal of 2 Veg Rolls, Large Fries and a Pepsi PET 475ml [Serves 1-2]",
                            "imageId": "9d83b7f6273d12556797ab595460dd15",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 39905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "HOT & CRISPY CHICKEN, WINGS",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220402",
                            "name": "Hot & Crispy Chicken - 8 pcs",
                            "category": "HOT & CRISPY CHICKEN, WINGS",
                            "description": "Save Rs. 182 & get 8pc signature Hot & crispy chicken [serves 3-4]",
                            "imageId": "uspplszjphtrwqn1alef",
                            "inStock": 1,
                            "price": 76857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003892",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.6",
                                "ratingCount": "32 ratings",
                                "ratingCountV2": "32"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220384",
                            "name": "Hot & Crispy Chicken - 6 pcs",
                            "category": "HOT & CRISPY CHICKEN, WINGS",
                            "description": "Flat 10% off on 6pc signature Hot & crispy chicken [serves 2-3]",
                            "imageId": "ygv0a2rzffhnfgbfajz4",
                            "inStock": 1,
                            "price": 62857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003866",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003870",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003872",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003875",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003880",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.0",
                                "ratingCount": "46 ratings",
                                "ratingCountV2": "46"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220669",
                            "name": "Hot & Crispy Chicken - 4 pcs",
                            "category": "HOT & CRISPY CHICKEN, WINGS",
                            "description": "Save Rs. 34 on 4 pc of signature Hot & Crispy Chicken at a deal price",
                            "imageId": "m7q813n17jh4nrhtt7ss",
                            "inStock": 1,
                            "price": 42857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003856",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.5",
                                "ratingCount": "60 ratings",
                                "ratingCountV2": "60"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220664",
                            "name": "Hot & Crispy Chicken- 2 pcs",
                            "category": "HOT & CRISPY CHICKEN, WINGS",
                            "description": "Signature Hot & crispy chicken",
                            "imageId": "n8ictcqllyfu5ojx3oci",
                            "inStock": 1,
                            "price": 22952,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003825",
                                "groupName": "Choose your Sides",
                                "choices": [
                                  {
                                    "id": "112319889",
                                    "name": "Chicken Popcorn - Large",
                                    "price": 24857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003828",
                                "groupName": "Choose your Snacks",
                                "choices": [
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003833",
                                "groupName": "Choose Your Beverage",
                                "choices": [
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319886",
                                    "name": "Pepsi Black Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319888",
                                    "name": "7UP Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319882",
                                    "name": "Mirinda Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003837",
                                "groupName": "Choose your Dips",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              },
                              {
                                "groupId": "134003840",
                                "groupName": "Choose your Desserts",
                                "choices": [
                                  {
                                    "id": "112319885",
                                    "name": "Coffee Mousse Cake",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319874",
                                    "name": "Chocolate Mud Pie",
                                    "price": 12857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.7",
                                "ratingCount": "68 ratings",
                                "ratingCountV2": "68"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220748",
                            "name": "Hot Chicken Wings - 4 pcs",
                            "category": "HOT & CRISPY CHICKEN, WINGS",
                            "description": "Seasoned, signature KFC chicken wings",
                            "imageId": "ubpofq5tlhdgwh2lzo8d",
                            "inStock": 1,
                            "price": 17905,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003817",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.3",
                                "ratingCount": "223 ratings",
                                "ratingCountV2": "223"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220708",
                            "name": "Hot & Crispy Chicken - 1 pc",
                            "category": "HOT & CRISPY CHICKEN, WINGS",
                            "description": "Signature Hot & crispy chicken",
                            "imageId": "scl1wyh0yg3saadaakbk",
                            "inStock": 1,
                            "price": 11524,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003811",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.7",
                                "ratingCount": "34 ratings",
                                "ratingCountV2": "34"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "BONELESS CHICKEN POPCORN",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "16702996",
                            "name": "Chicken Popcorn - Large",
                            "category": "BONELESS CHICKEN POPCORN",
                            "description": "Signature bite-sized boneless chicken, with special spices",
                            "imageId": "xwunbsyx5mjosb47pgpi",
                            "inStock": 1,
                            "price": 24857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003800",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.7",
                                "ratingCount": "411 ratings",
                                "ratingCountV2": "411"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "58107464",
                            "name": "Chicken Popcorn - Medium",
                            "category": "BONELESS CHICKEN POPCORN",
                            "description": "Signature bite-sized boneless chicken, with special spices",
                            "imageId": "vq4hhfaphd4fam2kieqq",
                            "inStock": 1,
                            "price": 16857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003789",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.5",
                                "ratingCount": "166 ratings",
                                "ratingCountV2": "166"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "58107465",
                            "name": "Chicken Popcorn - Regular",
                            "category": "BONELESS CHICKEN POPCORN",
                            "description": "Signature bite-sized boneless chicken, with special spices",
                            "imageId": "xzzsjnmakrosu2i5qatn",
                            "inStock": 1,
                            "price": 11524,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "134003781",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "113223315",
                                    "name": "Smoky Red Grilled Chicken - 1 pc",
                                    "price": 12476,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.2",
                                "ratingCount": "107 ratings",
                                "ratingCountV2": "107"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "GRILLED SMOKY RED CHICKEN",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "67884761",
                            "name": "Smoky Red Grilled Chicken - 5 pc",
                            "category": "GRILLED SMOKY RED CHICKEN",
                            "description": "Flat 20% off on 5pc Smoky red grilled chicken [serves 2]",
                            "imageId": "ewi33xnqju9f6ezzwhbk",
                            "inStock": 1,
                            "price": 52857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136552981",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319891",
                                    "name": "Classic Chicken Roll",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.2",
                                "ratingCount": "39 ratings",
                                "ratingCountV2": "39"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "71050675",
                            "name": "Smoky Red Grilled Chicken - 2 pc",
                            "category": "GRILLED SMOKY RED CHICKEN",
                            "description": "Spicy, red, grilled chicken",
                            "imageId": "e2gbhuf1hprednohf5yt",
                            "inStock": 1,
                            "price": 24857,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136552979",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319871",
                                    "name": "Pepsi PET 475ml",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319890",
                                    "name": "Pack of 2 Dips",
                                    "price": 5714,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319878",
                                    "name": "French Fries - Large",
                                    "price": 11905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319877",
                                    "name": "Hot Chicken Wings - 4 pcs",
                                    "price": 17905,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.3",
                                "ratingCount": "53 ratings",
                                "ratingCountV2": "53"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220761",
                            "name": "Smoky Red Grilled Chicken - 1 pc",
                            "category": "GRILLED SMOKY RED CHICKEN",
                            "description": "Spicy, red, grilled chicken",
                            "imageId": "wfmeqvdcmqmv1wpshbqh",
                            "inStock": 1,
                            "price": 12476,
                            "variants": {},
                            "variantsV2": {},
                            "addons": [
                              {
                                "groupId": "136552972",
                                "groupName": "This goes well with",
                                "choices": [
                                  {
                                    "id": "112319892",
                                    "name": "Tandoori Masala Dip",
                                    "price": 2857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319884",
                                    "name": "French Fries - Medium",
                                    "price": 9905,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319883",
                                    "name": "Chicken Popcorn - Medium",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319881",
                                    "name": "Chicken Popcorn - Regular",
                                    "price": 11524,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319876",
                                    "name": "Chocolate Lava Cake",
                                    "price": 10857,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319873",
                                    "name": "Pepsi Can 300 ml",
                                    "price": 5710,
                                    "inStock": 1,
                                    "isVeg": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319880",
                                    "name": "Hot & Crispy Chicken- 2 pcs",
                                    "price": 22952,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  },
                                  {
                                    "id": "112319875",
                                    "name": "Double Chicken Roll",
                                    "price": 16857,
                                    "inStock": 1,
                                    "isEnabled": 1
                                  }
                                ],
                                "maxAddons": -1,
                                "maxFreeAddons": -1
                              }
                            ],
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.8",
                                "ratingCount": "36 ratings",
                                "ratingCountV2": "36"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "FLAT 179 MEALS/BUCKET",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "133351632",
                            "name": "Classic Zinger Burger",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Signature chicken burger made with a crunchy chicken fillet, veggies & a delicious mayo sauce",
                            "imageId": "d5bc5b32dd177f5f207cad66556a572b",
                            "inStock": 1,
                            "price": 19905,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "133351630",
                            "name": "Zinger Burger - Veg",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Signature veg burger with crispy patties, veggies & a tangy sauce",
                            "imageId": "a403a55dc5b74cc6acfcfa755f30c165",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 18857,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "121819594",
                            "name": "Tandoori Zinger Burger",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Chicken zinger with a delicious tandoori sauce",
                            "imageId": "af3699168db40a2dbadc372d87338e97",
                            "inStock": 1,
                            "price": 20857,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "121819590",
                            "name": "2 Chicken Krisper Burgers",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "2 delicious chicken value burgers - at a deal price",
                            "imageId": "ojrr9cfvsoimihjruvht",
                            "inStock": 1,
                            "price": 24857,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.2",
                                "ratingCount": "4 ratings",
                                "ratingCountV2": "4"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "104580070",
                            "name": "4 Pc Hot Wings & Medium Fries",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "4 Pieces of Hot Wings with medium Fries",
                            "imageId": "tju9pxusa0ppuvb1shpn",
                            "inStock": 1,
                            "price": 27810,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "104580068",
                            "name": "4 Pc Hot Wings & Regular Popcorn",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "4 Pieces of Hot Wings with Regular Popcorn",
                            "imageId": "jdkgdirs1znbgvsxqex2",
                            "inStock": 1,
                            "price": 29429,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.8",
                                "ratingCount": "32 ratings",
                                "ratingCountV2": "32"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "104580062",
                            "name": "2 Veg Patty & Medium Fries",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "2 Pieces of Veg Patty with Medium Fries",
                            "imageId": "tpcbqziukcvrv2u2g8gq",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 25429,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "104580061",
                            "name": "1 Regular Popcorn & Medium Fries",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Enjoy a Regular Popcorn with Medium Fries",
                            "imageId": "xwdj25op2ugdkfz5jzyy",
                            "inStock": 1,
                            "price": 21429,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "104580060",
                            "name": "1 Hot & Crispy with Regular Popcorn",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "1 Piece Hot & Crispy with Regular Popcorn",
                            "imageId": "vgekadsm4wrlpy4a4hdz",
                            "inStock": 1,
                            "price": 23048,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "104580059",
                            "name": "1 Hot & Crispy with Medium Fries",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "1 Hot & Crispy with Medium Fries",
                            "imageId": "g3048al3czj06kvygxah",
                            "inStock": 1,
                            "price": 21429,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "121819563",
                            "name": "2 pc Hot & Crispy Chicken",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Signature Hot & crispy chicken",
                            "imageId": "zoft44ahx3iognqn5atm",
                            "inStock": 1,
                            "price": 22952,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "133351610",
                            "name": "Large Chicken Popcorn",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Signature bite-sized boneless chicken, with special spices",
                            "imageId": "p6yghgzpqqlooi2lziyj",
                            "inStock": 1,
                            "price": 24857,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "133351608",
                            "name": "2 Pcs Smoky Red Chicken",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Spicy, red, grilled chicken",
                            "imageId": "vbrmwts0w2qshfuuf2fi",
                            "inStock": 1,
                            "price": 24857,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "133351607",
                            "name": "Rice Bowlz - Classic Chicken",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Hot & Crispy Chicken rice bowl mixed with spicy gravy",
                            "imageId": "a74de1a2b59bf60d616d458b7e78bd1a",
                            "inStock": 1,
                            "price": 22952,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "133351606",
                            "name": "Rice Bowlz- Smoky Red Chicken",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Smoky Red Chicken rice bowl mixed with spicy gravy",
                            "imageId": "0c92428379d15d91c401e92044740d6e",
                            "inStock": 1,
                            "price": 22952,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "133351605",
                            "name": "Rice Bowlz - Popcorn Chicken",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Popcorn Chicken rice bowl mixed with spicy gravy",
                            "imageId": "9e57b3b9478a4a0b114b8ba4e1b5be89",
                            "inStock": 1,
                            "price": 22952,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "133351604",
                            "name": "Rice Bowlz - Veg",
                            "category": "FLAT 179 MEALS/BUCKET",
                            "description": "Veg rice bowl mixed with spicy gravy",
                            "imageId": "b55628a57b4ae927013617605d4db6e6",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 19905,
                            "finalPrice": 17900,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "offerTags": [
                              {}
                            ],
                            "itemBadge": {},
                            "badgesV2": {},
                            "itemNudgeType": "FinalPrice",
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "SIDES AND DIPS",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "125145049",
                            "name": "Chicken Leg Piece - 1 pc",
                            "category": "SIDES AND DIPS",
                            "description": "Crispy Chicken Leg Piece",
                            "imageId": "pss6auktmzkk1iaclhj2",
                            "inStock": 1,
                            "price": 12500,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "99453055",
                            "name": "Peri Peri Chicken Strips - 3 pc",
                            "category": "SIDES AND DIPS",
                            "description": "3 Pieces Spicy Peri Peri chicken boneless strips",
                            "inStock": 1,
                            "price": 17905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "NONVEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.1",
                                "ratingCount": "9 ratings",
                                "ratingCountV2": "9"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63220759",
                            "name": "2 pc Veg Patty",
                            "category": "SIDES AND DIPS",
                            "description": "Delicious, crispy, veg add-on",
                            "imageId": "v9thnyukkkv47ifzmxfa",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 15524,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.9",
                                "ratingCount": "23 ratings",
                                "ratingCountV2": "23"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "62923815",
                            "name": "French Fries - Large",
                            "category": "SIDES AND DIPS",
                            "description": "Jazz up your meal with crispy french fries",
                            "imageId": "r93ljtqjnlpn2xr24dln",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 11905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "3.6",
                                "ratingCount": "57 ratings",
                                "ratingCountV2": "57"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "51244566",
                            "name": "French Fries - Medium",
                            "category": "SIDES AND DIPS",
                            "description": "Jazz up your meal with crispy french fries",
                            "imageId": "n4ry9mep4uisjri10uqp",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 9905,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.4",
                                "ratingCount": "95 ratings",
                                "ratingCountV2": "95"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "56344347",
                            "name": "Pack of 4 Dips",
                            "category": "SIDES AND DIPS",
                            "description": "Adding dips is always a good idea! (Save Rs. 5)",
                            "imageId": "gvtc5ybblsammx3nemfo",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 10952,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.5",
                                "ratingCount": "23 ratings",
                                "ratingCountV2": "23"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "56344348",
                            "name": "Pack of 2 Dips",
                            "category": "SIDES AND DIPS",
                            "description": "Adding dips is always a good idea!",
                            "imageId": "yblqo1sys6x3sdszulqq",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 5714,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.8",
                                "ratingCount": "62 ratings",
                                "ratingCountV2": "62"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "63005791",
                            "name": "Tandoori Masala Dip",
                            "category": "SIDES AND DIPS",
                            "description": "Special tandoori flavor dip to add a twist to your meal",
                            "imageId": "icpcqoet1ssvzkvd4g3m",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 2857,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.9",
                                "ratingCount": "41 ratings",
                                "ratingCountV2": "41"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "95811094",
                            "name": "Nashville Hot Pepper Sauce Bottle",
                            "category": "SIDES AND DIPS",
                            "description": "Nashville in a bottle! Our signature hot, peppery sauce which pairs well with all things KFC.",
                            "imageId": "vjpd4gm5eowrmer0hhqm",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 18952,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "95811093",
                            "name": "Dynamite Spicy Mayo Sauce Bottle",
                            "category": "SIDES AND DIPS",
                            "description": "Spicy, punchy mayo?bottled up just for you & your favorite KFC! Our signature launch.",
                            "imageId": "yjplgscd126mummkpfm6",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 18952,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                    "title": "DESSERTS & BEVERAGES",
                    "itemCards": [
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "100871966",
                            "name": "Chocolate Lava Cake",
                            "category": "DESSERTS & BEVERAGES",
                            "description": "New Soft Chocolate cake with a gooey center- perfect chocolaty end to every meal",
                            "imageId": "thb7rrdooctsnknsnatz",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 10857,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.5",
                                "ratingCount": "17 ratings",
                                "ratingCountV2": "17"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "69509800",
                            "name": "Chocolate Mud Pie",
                            "category": "DESSERTS & BEVERAGES",
                            "description": "Chocolate lovers unite! Say hello to our delicious, new, creamy chocolate & cake dessert- a must try!",
                            "imageId": "fhtrvjerl7l2ck1crwhp",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 12857,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.8",
                                "ratingCount": "20 ratings",
                                "ratingCountV2": "20"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "69509801",
                            "name": "Coffee Mousse Cake",
                            "category": "DESSERTS & BEVERAGES",
                            "description": "Coffee, chocolate, cake?what's not to love? Enjoy our delicious, new dessert for those coffee-licious temptations!",
                            "imageId": "cb0kmlqdl0kjiri0qii9",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 12857,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.7",
                                "ratingCount": "20 ratings",
                                "ratingCountV2": "20"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "51751775",
                            "name": "Pepsi PET 475ml",
                            "category": "DESSERTS & BEVERAGES",
                            "description": "Cheers to fizz that makes you Rise Up Baby! Order Pepsi to make your food rise up to your level of awesome!",
                            "imageId": "ibrkax41b0rltgjvb0k1",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 5714,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {
                              "text": "Bestseller",
                              "textColor": "#ffffff",
                              "topBackgroundColor": "#d53d4c",
                              "bottomBackgroundColor": "#b02331"
                            },
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "isBestseller": true,
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.8",
                                "ratingCount": "71 ratings",
                                "ratingCountV2": "71"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "115060333",
                            "name": "Pepsi Can 300 ml",
                            "category": "DESSERTS & BEVERAGES",
                            "description": "Cheers to fizz that makes you Rise Up Baby! Order Pepsi to make your food rise up to your level of awesome!",
                            "imageId": "zzsh8emh9fz3v2puiijd",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 5710,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {}
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "115060331",
                            "name": "7UP Can 300 ml",
                            "category": "DESSERTS & BEVERAGES",
                            "description": "7UP is the ultimate Super-Duper Refresher. Every sip of this crisp lemon flavour refreshes you to the core.",
                            "imageId": "qn00mdssgatf9yjauq8o",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 5710,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.7",
                                "ratingCount": "18 ratings",
                                "ratingCountV2": "18"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "115060329",
                            "name": "Pepsi Black Can 300 ml",
                            "category": "DESSERTS & BEVERAGES",
                            "description": "Enjoy Pepsi Black to make your food rise up to max levels of awesome with Zero sugar and Zero guilt!",
                            "imageId": "rop9dooensk8zq97ssqj",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 5710,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.3",
                                "ratingCount": "27 ratings",
                                "ratingCountV2": "27"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      },
                      {
                        "card": {
                          "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                          "info": {
                            "id": "115060328",
                            "name": "Mirinda Can 300 ml",
                            "category": "DESSERTS & BEVERAGES",
                            "description": "Great orange taste and sparking bubbles encourage you to be carefree, spontaneous and playful!",
                            "imageId": "zcwmo9x7sbvhehuz59td",
                            "inStock": 1,
                            "isVeg": 1,
                            "price": 5710,
                            "variants": {},
                            "variantsV2": {},
                            "itemAttribute": {
                              "vegClassifier": "VEG"
                            },
                            "ribbon": {},
                            "type": "ITEM",
                            "itemBadge": {},
                            "badgesV2": {},
                            "ratings": {
                              "aggregatedRating": {
                                "rating": "4.9",
                                "ratingCount": "30 ratings",
                                "ratingCountV2": "30"
                              }
                            }
                          },
                          "analytics": {},
                          "hideRestaurantDetails": true
                        }
                      }
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                    "type": "FSSAI",
                    "imageId": "fssai_final_edss9i",
                    "text": [
                      "License No. 12818008000314"
                    ]
                  }
                }
              },
              {
                "card": {
                  "card": {
                    "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                    "name": "KFC",
                    "area": "Liluah",
                    "completeAddress": "KFC Forum Rangoli Mall 212,Girish Ghosh Road, Belur Howrah West Bengal-711202"
                  }
                }
              }
            ]
          }
        }
      }
    }
  ],
  "firstOffsetRequest": true,
  "isQCLink": false
}